<template>
  <div>
    <no-ssr>
      <div class="ActGuoQingBuoy" :class="{ 'ON': isShow }" @click="navToGuoQingAct">
        <!--       <div class="icon_close"
            @click.stop="closeBuoy"
       >
         <i class="iconfont icon-cha"></i>
       </div>-->

        <div class="time-box">
          <span class="h">{{ times.h }}：</span>
          <span class="m">{{ times.m }}：</span>
          <span class="s">{{ times.s }}{{ times.hm }}</span>
        </div>

        <i class="icon_close2" @click.stop="closeBuoy"></i>

      </div>
    </no-ssr>
  </div>
</template>

<script>
import { fnBasic } from "@/fn/_fn";
import { ACTIVE_GUOQING } from "@/constant/_constant/CON_BASIC";
import { fnLocalStorage } from "@/fn";
import { MODEL_GUO_QING_BUOY, MODEL_GUO_QING_FLOAT } from "@/constant/MODELS";
import mixinCountDown from "@/mixins/mixinCountDown";

export default {
  name: "ActGuoQingBuoy",
  mixins: [mixinCountDown],
  data() {
    return {
      isShow: false
    }
  },
  mounted() {
    this.getFloatShowState();
    this.initTimer()
  },

  methods: {
    navToGuoQingAct() {
      fnBasic.navigationTo(ACTIVE_GUOQING)
    },

    closeBuoy() {
      this.isShow = false;
      fnLocalStorage.setItemDate(MODEL_GUO_QING_BUOY);
    },

    getFloatShowState() {
      let flag = fnLocalStorage.getItemDate(MODEL_GUO_QING_BUOY);
      this.isShow = !flag;
    },

  },
  beforeDestroy() {
    this.clearTimer();
  },
}
</script>

<style lang="scss" scoped>
.ActGuoQingBuoy {
  display: block;
  transition: all 0.5s ease;
  @include BgImage(139px, 130px, 'act/guoqing/icon_fb2-3.png', 1);
  background-size: 139px 130px;
  vertical-align: middle;
  cursor: pointer;
  position: fixed;
  right: -999px;
  top: 150px;
  z-index: 99;

  &.ON {
    right: 0;
  }


  .icon_close2 {
    @include BgImage(20px, 20px, 'pay/act-company/icon_close2.png');
    @include Position(1, 2, 50%, 126px);
    transform: translateX(50%);
    cursor: pointer;
  }

  .time-box {
    //width: 100px;
    height: 18px;
    box-sizing: border-box;
    position: absolute;
    bottom: 17px;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
    padding-left: 3px;
    white-space: nowrap;

    span {
      display: inline-block;
      width: 18px;
      height: 18px;
      font-size: 12px;
      font-weight: bold;
      color: #FFFFFF;
      line-height: 18px;
      //margin-right: 9px;
    }

    .h {}

    .m {}

    .s {
      width: 27px;
    }


  }

}
</style>
